import { render, staticRenderFns } from "./TarjetaDatos.vue?vue&type=template&id=4e011e57"
import script from "./TarjetaDatos.vue?vue&type=script&lang=js"
export * from "./TarjetaDatos.vue?vue&type=script&lang=js"
import style0 from "./TarjetaDatos.vue?vue&type=style&index=0&id=4e011e57&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCard,VCardSubtitle,VDivider,VIcon,VSheet})
